var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.publishedClients.length)?_c('div',{staticClass:"publish hvh-flex align-center font-sm no-line-height"},[_c('v-icon',{staticClass:"ml-1",attrs:{"color":"white","small":""}},[_vm._v("mdi-checkbox-marked-circle")]),_c('span',{staticClass:"ml-1"},[_vm._v("Published to: "+_vm._s(_vm.publishedClients))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }